import type { ValidationReportSection } from '../lib/customsMessages';

// Single styled presentation for a customs message's validation report, used everywhere one is
// shown. Previously this was rendered two different ways for the same CUSDEC ML data — a
// styled errors/warnings list on the business-level inbound message detail page, and a raw
// JsonBlock dump on the dedicated CUSDEC ML console — see
// apps/integration/docs/frontend-ux-audit-2026-08.md §5. This is now the one presentation,
// generalized with labeled sections so it also covers CUSDEC ML's extra "XSD errors" bucket and
// Etat de Chargement/Tryptique's simpler errors/warnings-only shape.
export function ValidationReportView({ sections }: { sections: ValidationReportSection[] }) {
  const visible = sections.filter((section) => section.items.length > 0);
  if (visible.length === 0) return null;

  return (
    <div className="stack-list">
      {visible.map((section) => (
        <div key={section.label}>
          <h4>{section.label} ({section.items.length})</h4>
          <ul className="plain-list">
            {section.items.map((item, index) => (
              <li key={`${section.label}-${index}`} className={section.tone === 'error' ? 'form-error' : 'field-warning'}>{item}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
